export default "__VITE_ASSET__JkoQWCmk__"